import React, { FC } from "react";
import * as Styled from "./startConversation.styles";
import { useTheme } from "@cellectenergy/cellect-react-components";
import { Typography } from "@mui/material";

export const CellectAdress: FC = () => {
  const theme = useTheme();
  return (
    <Styled.CellectInfoContainer>
      <Typography
        color={theme.palette.common.corporateColors.primary.white}
        variant="body-medium"
      >
        Av. de Josep Tarradellas,
      </Typography>
      <Typography
        color={theme.palette.common.corporateColors.primary.white}
        variant="body-medium"
      >
        +34 931 26 02 11
      </Typography>
      <Typography
        color={theme.palette.common.corporateColors.primary.white}
        variant="body-medium"
      >
        8, 4-4, 08029 Barcelona, Spain
      </Typography>
      <Typography
        color={theme.palette.common.corporateColors.primary.white}
        variant="body-medium"
      >
        info@cellectenergy.com
      </Typography>
    </Styled.CellectInfoContainer>
  );
};
